module.exports = __webpack_public_path__ + "static/media/logo.84a6092f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/logo.png
// module id = 408
// module chunks = 0